import React, { FC } from 'react';
import { SvgIcon } from '@common/sprites';
import classes from './classes.module.scss';

type SatisfactionGuaranteedItem = {
  id: string;
  title: string;
  description: string;
  icon_url?: string;
};

type Props = {
  title?: string;
  content: {
    items: SatisfactionGuaranteedItem[];
  };
};

const SatisfactionGuaranteedSection: FC<Props> = ({
  title = '',
  content = { items: [] }
}) => {
  const { items = [] } = content;

  if (!items || items.length === 0) return null;

  const renderItem = (item: SatisfactionGuaranteedItem, itemIndex: number) => {
    const {
      id, title: itemTitle, description, icon_url: iconUrl
    } = item;

    return (
      <div key={ id || itemIndex } className={ classes.item }>
        <div className={ classes.iconContainer }>
          {iconUrl ? (
            <img src={ iconUrl } alt={ itemTitle } className={ classes.icon } />
          ) : (
            <SvgIcon id={ id } className={ classes.icon } />
          )}
        </div>
        <div className={ classes.itemTitle }>{itemTitle}</div>
        <div className={ classes.itemDescription }>{description}</div>
      </div>
    );
  };

  return (
    <div
      className={ classes.container }
      data-testid="HP-satisfaction-guaranteed-section"
    >
      {title && (
        <div className={ classes.title }>
          {title}
        </div>
      )}
      <div className={ classes.itemsContainer }>
        {items.map((item, itemIndex) => renderItem(item, itemIndex))}
      </div>
    </div>
  );
};

export default SatisfactionGuaranteedSection;
